import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { queryClassPaperEvaluation, getWeekSendMessage, editNoteForSellOrder, sendPaperStudentMessage, getUrlpaperMaster } from '@/api'
import urlBase from '@/utils/urlBase'

@Component({ name: 'paperFeedBack' })
export default class PaperFeedBack extends Vue {
  @Prop({ type: Object, default: {} }) activeStudent !: object;
  @Prop({ type: Number, default: {} }) pageType !: number; // 1，个人消息 2，班级消息

  created () {
    this.activeData = this.activeStudent
    this.getSellOrderIdl(this.activeStudent)
  }

  private uploadUrl = {
    // imgs: 'http://192.168.0.116:10069/upload/evaluation/image'
    imgs: urlBase.eduBaseUrl + 'upload/evaluation/image'
  }

  private activeWeek: any = 0
  private messageType: any = null
  private weeksVisible: any = false
  private weeksradio: any = null
  private checkedWeeks: any = []
  private weekList: any = []
  private activeData: any = {}
  private urlVisible: any = false
  private paperUrl: any = null
  private savesuccess: any = false
  // 传入的学员信息
  @Watch('activeStudent')
  activeStudentchange (val: any, old: any) {
    if (JSON.stringify(this.evaluationAllWeekList.evaluationAllWeek) !== this.evaluationAllWeekListCopy && JSON.stringify(val) !== JSON.stringify(old)) {
      if (this.$store.state.user.roles.find((item: any) => item.indexOf('运营专员') > -1 || item.indexOf('运营主管') > -1 || item.indexOf('教研') > -1)) {
        this.loading = this.$loading({
          lock: true,
          text: '自动保存中',
          spinner: 'el-icon-loading'
        })
        this.savestudentDetails(1)
      }
      setTimeout(() => {
        this.getSellOrderIdl(val)
      }, 500)
    } else {
      this.getSellOrderIdl(val)
    }
  }

  private loading: any = false
  private evaluationAllWeekList: any = null
  private evaluationAllWeekListCopy: any = null
  // 获取详情
  private async getSellOrderIdl (val: any) {
    this.loading = this.$loading({
      lock: true,
      text: '加载中',
      spinner: 'el-icon-loading'
    })
    this.activeData = val
    const result: any = await queryClassPaperEvaluation({ sellOrderId: val.sellOrderId, classId: val.classId, from: this.pageType })
    this.evaluationAllWeekList = result
    this.evaluationAllWeekListCopy = JSON.stringify(this.evaluationAllWeekList.evaluationAllWeek)
    this.loading.close()
  }

  // 修改反馈接口
  private async savestudentDetails (type: any) {
    if (type === 1) {
      this.loading.close()
      const { error }: any = await editNoteForSellOrder({ changeList: this.evaluationAllWeekList.evaluationAllWeek, sellOrderId: this.activeData.sellOrderId, classId: this.activeData.classId })
      if (!error) {
        this.$message({ type: 'success', message: '修改反馈成功', duration: 2000 })
      }
    } else {
      if (JSON.stringify(this.evaluationAllWeekList.evaluationAllWeek) === this.evaluationAllWeekListCopy) {
        this.$message({ type: 'warning', message: '考勤作业未任何修改', duration: 2000 })
        this.savesuccess = true
      } else {
        const { error }: any = await editNoteForSellOrder({ changeList: this.evaluationAllWeekList.evaluationAllWeek, sellOrderId: this.activeData.sellOrderId, classId: this.activeData.classId })
        if (!error) {
          this.$message({ type: 'success', message: '修改反馈成功', duration: 2000 })
          this.savesuccess = true
        }
      }
    }
  }

  private async sureSendClick (type: any) {
    this.messageType = type
    // sellOrderId: this.activeData.sellOrderId
    const data: any = await getWeekSendMessage({ messageType: this.messageType, classId: this.activeData.classId })
    this.weekList = data.weekStrList
    this.weeksVisible = true
  }

  private async sureSend () {
    await this.$emit('fatherMethod') // 课程内容保存
    await this.savestudentDetails(null) // 学生反馈
    if (this.savesuccess) {
      const list: any = []
      this.checkedWeeks.forEach((item: any) => {
        list.push(item.weekStr)
      })
      const { error }: any = await sendPaperStudentMessage({
        // sellOrderId: this.activeData.sellOrderId,
        classId: this.activeData.classId,
        messageType: this.messageType,
        weekStr: this.messageType === 1 ? [this.weeksradio] : list
      })
      if (!error) {
        const text = this.messageType === 1 ? '发布推送成功' : '更新推送成功'
        this.$message({ message: text, type: 'success' })
        this.resetDialog()
      }
      this.savesuccess = false
    }
  }

  private async getURL () {
    const result: any = await getUrlpaperMaster({ classId: this.activeData.classId })
    if (result && !result.error) {
      this.paperUrl = result
      this.urlVisible = true
    }
  }

  private async copylink () {
    const url: any = this.$refs.url
    url.select()
    document.execCommand('Copy')
    this.$message({ message: '复制成功', type: 'success' })
  }

  private async resetDialog () {
    this.weeksVisible = false
    this.weeksradio = null
    this.checkedWeeks = []
    this.messageType = null
  }
}
